
const constants = {
    TYPES: {
        filled: "filled",
        clear: "clear"
    }
}

export default constants;